module.exports = __webpack_public_path__ + "static/media/34-south-end.8024f565.jpeg";